import { render, staticRenderFns } from "./Assess.vue?vue&type=template&id=6877240a"
import script from "./Assess.vue?vue&type=script&lang=js"
export * from "./Assess.vue?vue&type=script&lang=js"
import style0 from "./Assess.vue?vue&type=style&index=0&id=6877240a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports